import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';

class SeminarTuksom1 extends Component {
  state = {
    registered: {}
  };

  componentDidMount() {
    // Load saved registration state from localStorage
    const saved = localStorage.getItem("registered_tuksom");
    if (saved) {
      this.setState({ registered: JSON.parse(saved) });
    }
  }

  handleRegister = (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      // Ask to unregister with PIN
      const pin = window.prompt("Enter PIN to unregister:");
      if (pin === "2323") {
        this.setState((prevState) => {
          const updated = { ...prevState.registered };
          delete updated[id];
          localStorage.setItem("registered_tuksom", JSON.stringify(updated));
          return { registered: updated };
        });
        alert("Unregistered successfully.");
      } else if (pin !== null) {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      // Ask to register
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        this.setState((prevState) => {
          const updated = { ...prevState.registered, [id]: true };
          localStorage.setItem("registered_tuksom", JSON.stringify(updated));
          return { registered: updated };
        });
      }
    }
  };

  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue",
            cursor: "pointer"
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className='RosterTuesday1'>
        <h3>Aikido Tuksom Dojo Participants Day 1</h3>
        <br /><br />

        {this.renderParticipant(1, "Mr.Natthaphat Ingsakulsomboon")}
        <br />
        {this.renderParticipant(2, "Mr.Jacques Adam du Plessis")}
        <br />
        {this.renderParticipant(3, "นายณัฐสุทธิ์ หัตถกรรม")}
        <br />
        {this.renderParticipant(4, "ด.ญ.อนันตญา กุลธนากร")}
        <br />
        {this.renderParticipant(5, "นางสาวมนัสพร เอกวิสิฐ")}
        <br />
        {this.renderParticipant(6, "Mr.Choosak Phumueang")}
        <br />
        {this.renderParticipant(7, "Mr.Chatchawan Egawarin")}
        <br />
        {this.renderParticipant(8, "นายฐาน์กุญช์ แก้วอิสราพันธ์")}
        <br />

        <div>
          ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...
        </div>
        <br /><br />
        <div>Powered by</div>
        <img className='logo2' src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarTuksom1;
